import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeLogisticsRouteMutationVariables = Types.Exact<{
  input: Types.MergeLogisticsRouteInput;
}>;


export type MergeLogisticsRouteMutation = { __typename?: 'Mutation', mergeLogisticsRoute: { __typename?: 'LogisticsRoutePayload', logisticsRoute?: { __typename?: 'LogisticsRouteStateData', tenantId: string, routeId: string, code: string, name: string, description: string, isActive: boolean, isAdHoc: boolean, driverId?: string | null, defaultVehicleId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, stops: Array<{ __typename?: 'RouteStopStateData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteLogisticsRouteMutationVariables = Types.Exact<{
  input: Types.DeleteLogisticsRouteInput;
}>;


export type DeleteLogisticsRouteMutation = { __typename?: 'Mutation', deleteLogisticsRoute: { __typename?: 'LogisticsRoutePayload', logisticsRoute?: { __typename?: 'LogisticsRouteStateData', tenantId: string, routeId: string, code: string, name: string, description: string, isActive: boolean, isAdHoc: boolean, driverId?: string | null, defaultVehicleId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, stops: Array<{ __typename?: 'RouteStopStateData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RouteStopStateFieldsFragment = { __typename?: 'RouteStopStateData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string };

export type LogisticsRouteStateFieldsFragment = { __typename?: 'LogisticsRouteStateData', tenantId: string, routeId: string, code: string, name: string, description: string, isActive: boolean, isAdHoc: boolean, driverId?: string | null, defaultVehicleId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, stops: Array<{ __typename?: 'RouteStopStateData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string }> };

export const RouteStopStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment RouteStopStateFields on RouteStopStateData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}
    `, {"fragmentName":"RouteStopStateFields"});
export const LogisticsRouteStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsRouteStateFields on LogisticsRouteStateData {
  tenantId
  routeId
  code
  name
  description
  isActive
  isAdHoc
  driverId
  defaultVehicleId
  stops {
    ...RouteStopStateFields
  }
  updatedAt
  updatedBy
}
    fragment RouteStopStateFields on RouteStopStateData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}`, {"fragmentName":"LogisticsRouteStateFields"});
export const MergeLogisticsRouteDocument = new TypedDocumentString(`
    mutation MergeLogisticsRoute($input: MergeLogisticsRouteInput!) {
  mergeLogisticsRoute(input: $input) {
    logisticsRoute {
      ...LogisticsRouteStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RouteStopStateFields on RouteStopStateData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}
fragment LogisticsRouteStateFields on LogisticsRouteStateData {
  tenantId
  routeId
  code
  name
  description
  isActive
  isAdHoc
  driverId
  defaultVehicleId
  stops {
    ...RouteStopStateFields
  }
  updatedAt
  updatedBy
}`);
export const DeleteLogisticsRouteDocument = new TypedDocumentString(`
    mutation DeleteLogisticsRoute($input: DeleteLogisticsRouteInput!) {
  deleteLogisticsRoute(input: $input) {
    logisticsRoute {
      ...LogisticsRouteStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment RouteStopStateFields on RouteStopStateData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}
fragment LogisticsRouteStateFields on LogisticsRouteStateData {
  tenantId
  routeId
  code
  name
  description
  isActive
  isAdHoc
  driverId
  defaultVehicleId
  stops {
    ...RouteStopStateFields
  }
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeLogisticsRoute: build.mutation<MergeLogisticsRouteMutation, MergeLogisticsRouteMutationVariables>({
      query: (variables) => ({ document: MergeLogisticsRouteDocument, variables })
    }),
    DeleteLogisticsRoute: build.mutation<DeleteLogisticsRouteMutation, DeleteLogisticsRouteMutationVariables>({
      query: (variables) => ({ document: DeleteLogisticsRouteDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeLogisticsRouteMutation, useDeleteLogisticsRouteMutation } = injectedRtkApi;
